import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import type { spendCategory, valueType } from '/business/shared/components/pages/question/types';
import {
  ERR_TYPE_ENUM_IS_DROPDOWN,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_DROPDOWN,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useEmissionSourceDropdown({
  valuesArray,
  label,
  emissionSourcePlaceholder,
  errMsg,
}: {
  valuesArray?: valueType[] | spendCategory[];
  label?: string;
  emissionSourcePlaceholder?: string;
  errMsg?: string;
}): StaticSharedField {
  const { t } = useTranslation();

  return {
    propName: 'emission_source',
    element: 'emission_source',
    type: FIELD_TYPE_DROPDOWN,
    label: label || 'Emission source:',
    placeholderI18nKey: 'business:QuestionPage.forms.refrigerants.refrigerantPlaceholder',
    dropdownTitleI18nKey: 'business:QuestionPage.forms.refrigerants.dropdownTitle',
    values: [
      ...(emissionSourcePlaceholder ? [{ name: 'empty', displayName: emissionSourcePlaceholder }] : []),
      ...(valuesArray && valuesArray.length > 1
        ? valuesArray.map((val: valueType | spendCategory) => ({
            name: val.name,
            displayName: val.displayName,
          }))
        : []),
    ],
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOEMISSIONSOURCEDROPDOWN',
        errStr: errMsg || t('business:Errors.supplierForm.emissionSource'),
      },
      {
        rule: ERR_TYPE_ENUM_IS_DROPDOWN,
        errCode: 'ERREMISSIONSOURCEDROPDOWNNOTFOUND',
        errStr: t('business:Errors.supplierForm.emissionSourceNotFound'),
      },
    ],
  };
}
